import { render, staticRenderFns } from "./site-history-section.vue?vue&type=template&id=6062312a&scoped=true&"
import script from "./site-history-section.vue?vue&type=script&lang=js&"
export * from "./site-history-section.vue?vue&type=script&lang=js&"
import style0 from "./site-history-section.vue?vue&type=style&index=0&id=6062312a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6062312a",
  null
  
)

export default component.exports